(function () {
  function revealSections(root) {
    var elements = (root || document).querySelectorAll('.fpg-reveal:not([data-fpg-reveal-ready])');

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(function (element) {
        element.classList.add('fpg-is-visible');
        element.setAttribute('data-fpg-reveal-ready', 'true');
      });
      return;
    }

    document.documentElement.classList.add('fpg-motion-ready');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fpg-is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    elements.forEach(function (element) {
      element.setAttribute('data-fpg-reveal-ready', 'true');
      observer.observe(element);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    revealSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    revealSections(event.target);
  });
})();
